import { call } from 'redux-saga/effects';
import { signalingScreenshareWhiteboardDataReceived } from 'features/content-whiteboard/actions';
import { initContentWhiteboardDataSaga } from 'features/content-whiteboard/sagas/initContentWhiteboardDataSaga';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';

export function* onScreenshareWhiteboardDataReceivedSaga(
  action: ReturnType<typeof signalingScreenshareWhiteboardDataReceived>
) {
  if (contentBoard.type !== 'screenshare' || contentBoard.id !== action.payload.feedId) {
    return;
  }

  yield call(initContentWhiteboardDataSaga, {
    ...action.payload,
    id: action.payload.feedId,
    type: 'screenshare',
  });
}
